import React from 'react';

import type { LinkReceiptProps } from './LinkReceipt.types';

/**
 * LinkReceipt — what an emailed link's page says once one is on its way: how
 * long it works, when or where it went, and where else to look. The reset,
 * email-change and verify-email pages all show one.
 */
export function LinkReceipt({
  rows,
  className = '',
}: LinkReceiptProps): React.JSX.Element {
  return (
    <dl
      className={[
        'divide-y divide-stroke-subtle rounded-lg border border-stroke-subtle text-body-md',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {rows.map(({ label, value, mono = false }) => (
        <div key={label} className="flex justify-between gap-4 px-3.5 py-2.5">
          <dt className="shrink-0 text-neutral-500">{label}</dt>
          <dd
            className={[
              'min-w-0 break-words text-right text-neutral-200',
              mono ? 'font-mono text-body-sm' : '',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            {value}
          </dd>
        </div>
      ))}
    </dl>
  );
}

export default LinkReceipt;
